import React, {  useState } from 'react'
import SidebarWidget from '../../../../widget/SidebarWidget/SidebarWidget'
import NavWidge2 from '../../../../widget/Nav/NavWidget2'
import { useHistory, useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { gql,useQuery } from '@apollo/client';
import { Button, Heading, Pane, Spinner, } from 'evergreen-ui';
import {  FlexyRow, FlexyRowJustify } from '../home/home.style';
import { GuestListTableContainer } from '../dues/dues.style';
import { ComplaintDetTabs } from './complaintsById.style';
import StatusPill from '../home/widgets/statusPill';
import {
  PageTitleText 
} from '../../../../widget/styledComponents/headings.style';
import { capitalizeFirstLetterOfWords, formatDate } from '../../../../widget/util';
import ChangeComplaintStatus from './widget/change_complaint_status';
import ChatInput from './widget/response_input_widget';
import ChatScreen from './widget/chatScreen';


function ComplaintById() {
const { id } = useParams();

  return (
    <div>
        <NavWidge2/>
        <div className='row'>
            <div className='col s12 m2 transparent'>
                <SidebarWidget/>
            </div>
            <div className='col s12 m10'>
                <ComplaintsByIdBodyWidget id={id} />
            </div>
        </div>
    </div>
  )
}



export default ComplaintById



export const FETCH_COMPLAINT_BY_ID = gql`
query Complaint_getById($complaintGetByIdId: ID!) {
  complaint_getById(id: $complaintGetByIdId) {
    _id
    facility
    property {
      _id
      facility
      owner {
        _id
        id
        email
        name
        phone
        photo
        facility
        isAccountActivated
        createdAt
      }
      resident {
        _id
        email
        name
        phone
        photo
        facility
        id
        isAccountActivated
        isAccountDeleted
        createdAt
      }
      type
      address
      numberOfRooms
      squareMeter
      createdAt
    }
    createdBy {
      _id
      name
      email
      address
    }
    title
    description
    images
    status
    hasComplaintBeenSeen
    complaintSeenTime
    createdAt
    id
    chat {
      msgType
      txt
      img
      by
      byType
      time
    }
  }
}
`;






function ComplaintsByIdBodyWidget(props) {
const id = props.id
const history = useHistory()



const { loading,error,data }  = useQuery(FETCH_COMPLAINT_BY_ID,{
    variables:{
        complaintGetByIdId:id
    }
  });
if (loading) return <Spinner/>;
if (error) return <p>Error: {error.message}</p>;
const res = data.complaint_getById


  return (
    <div className=''>
      <br/><br/>
      
      <div className='row'>
              <div className='col s12 ' style={{
                display:"flex"
              }}>
                  <span className='center' style={{
                        width:"30px",
                        height:"30px",
                        cursor: "pointer"
                    }}
                        onClick={()=>history.push("/")}
                    >
                        <i className='material-icons center'>arrow_backwards</i>
                    </span>
                  <PageTitleText>
                    Complaint detail
                  </PageTitleText>
              </div>
              
          </div>
      <div className='row'>
        <div className='col s12 m8'>
            <ResidentId res={res}/>
        </div>
        <div className='col s23 m4'>
            <ComplaintDetTabs>
                <h5>Choose Status</h5>
                <FlexyRowJustify>
                    <h5 className='value'>
                      {/* <StatusPill status={res.status}/> */}
                      <ChangeComplaintStatus dataRes={res} />
                    </h5>
                </FlexyRowJustify>   
            </ComplaintDetTabs>
        </div>
      </div>
      <div className='row' 

      >
        <div className='col s12 l4' >
            <GuestListTableContainer>  
              <div style={{
                height:"520px",
                overflow: "auto",
              }}>
                <Heading>
                    Title:
                    "{capitalizeFirstLetterOfWords(res.title)}"
                </Heading>
               
                <div className='mt-25'  style={{
                    display:"flex",
                    flexWrap:"wrap"
                  }}>
                    
                  {res.images && res.images.map((img)=> <div className='' style={{
                      width:"200px",
                      height:"200px",
                      background:"#eee",
                      borderRadius:"8px",
                      backgroung:`url('${img}')`,
                      marginRight:"10px"
                    }}>
                      <img src={img} alt="img" style={{
                        width:"200px",
                        height:"200px",
                      borderRadius:"8px",
                        
                      }} />
                    </div>)
                  }
                  {res.images.length ===0 || res.images === null 
                  ? <div className='grey mt-25' style={{
                    width:"200px",
                    height:"200px",
                    background:"#eee",
                    borderRadius:"8px"
                  }}>
                    <center>
                      <i className='material-icons large center grey' style={{
                        marginTop:"60px"
                      }}>filter_hdr</i>
                    </center>
  
                  </div>:''}
                </div>


                <div className=' p-16 mt-25' style={{
                  borderRadius:'8px',
                  background:"#eee",
                }}>
                  <Heading>Description:</Heading>
                  <p>
                      {capitalizeFirstLetterOfWords(res.description)}
                  </p>
                </div>
                
              </div>
            </GuestListTableContainer>
        </div>
        <div className='col s12 l8'>
            <GuestListTableContainer>   
              <ComplaintsByIdResponse id={res._id} />
              <ChatInput complaintId={res._id} />
            </GuestListTableContainer>  
        </div>
      </div>
     
      
    </div>
  )
}


export const COMPLAINT_RESPOND = gql`
mutation Complaint_addChatMessage($complaintAddChatMessageId: ID!, $message: ComplaintChatMessageInput!) {
  complaint_addChatMessage(id: $complaintAddChatMessageId, message: $message) {
    code
    success
    error
  }
}
`;

function ComplaintsByIdResponse(props) {

const [showChatScreen, setShowChatScreeen] = useState(true)
  return (
    <div>
        <div style={{
          display:"flex",
          justifyContent:"space-between",
          flexWrap:"wrap"
        }}>
          <Heading >Response</Heading><br/>
          <Button type='button' onClick={()=>{
            setShowChatScreeen(false)
            setTimeout(() => {
              setShowChatScreeen(true) 
            }, 2000);
          }} className='btn btn-flat center'>
            <i className='material-icons'>refresh</i>
          </Button>
        </div>
        <br/>
        <Pane>
            {showChatScreen &&
              <ChatScreen id={props.id}/>
            }
            <br/>
        </Pane>
      </div>   
  )
}











function ResidentId(props) {
  const ress = props.res.createdBy;
  const res = props.res;

 
    return (
    <FlexyRow>
        <ComplaintDetTabs>
            <h5>Resident Name</h5>
            <FlexyRowJustify>
            <h5 className='value'>{ress.name}</h5>
            </FlexyRowJustify>   
        </ComplaintDetTabs>
        <ComplaintDetTabs>
            <h5>Address</h5>
            <FlexyRowJustify>
            <h5 className='value'>{ress.address}</h5>
            </FlexyRowJustify>   
        </ComplaintDetTabs>
        <ComplaintDetTabs>
            <h5>Date</h5>
            <FlexyRowJustify>
            <h5 className='value'>{formatDate(res.createdAt)}</h5>
            </FlexyRowJustify>   
        </ComplaintDetTabs>
        <ComplaintDetTabs>
            <h5>Status</h5>
            <FlexyRowJustify>
            <h5 className='value'>
              <StatusPill status={res.status}/>
            </h5>
            </FlexyRowJustify>   
        </ComplaintDetTabs>
    </FlexyRow>
    )
}

